/*
 * FE "Frequently Paired Together" — cart-drawer recommendations carousel.
 *
 * Loaded once (via <script defer> in sections/drawer-cart.liquid); the MARKUP is rendered by
 * snippets/fe-frequently-paired.liquid inside #AjaxCartForm, so it rides the theme's cart AJAX
 * (add/remove/qty re-render #AjaxCartForm from the helper-cart section, re-inserting the element).
 *
 * A custom element's connectedCallback ALWAYS fires when it's inserted (incl. via innerHTML), so on
 * every cart re-render a fresh <frequently-paired-cart> connects, relocates itself to just above Total,
 * and binds the carousel. Styling lives in assets/fe-frequently-paired.css.
 */
if (typeof customElements !== "undefined" && !customElements.get("frequently-paired-cart")) {
  customElements.define(
    "frequently-paired-cart",
    class extends HTMLElement {
      connectedCallback() {
        var self = this;
        // Scope every lookup to the CART drawer — `.sidebar__body` exists in every drawer
        // (menu/search/cart), so an unscoped query would grab the wrong one.
        var drawer = this.closest("#site-cart-sidebar");
        var body = drawer && drawer.querySelector(".sidebar__body");
        if (!body) return;
        // Empty cart / no partners renders an empty <frequently-paired-cart> marker (no track). On connect it
        // clears ANY previously-relocated block + itself, so the block disappears when the cart empties.
        if (!this.querySelector("[data-pairing-track]")) {
          drawer.querySelectorAll("frequently-paired-cart").forEach(function (el) {
            el.remove();
          });
          return;
        }
        // Relocate out of #AjaxCartForm to the END of the scrollable body — NOT the sticky footer (a block
        // there makes the footer tall enough to overlap the cart rows). CSS then pins us to the bottom of
        // the body (margin-top:auto) so we sit just above Total without floating mid-drawer on tall screens.
        if (this.parentElement !== body || this !== body.lastElementChild) {
          drawer.querySelectorAll("frequently-paired-cart").forEach(function (el) {
            if (el !== self) el.remove(); // drop the previous render
          });
          // Moving an already-connected custom element isn't guaranteed to re-fire connectedCallback,
          // so DON'T return — fall through and bind the carousel right after the move. The _init guard
          // below keeps it idempotent even if the move DOES re-fire connectedCallback.
          body.appendChild(this);
        }
        if (this._init) return;
        var tries = 0;
        var init = function () {
          var track = self.querySelector("[data-pairing-track]");
          var prev = self.querySelector("[data-pairing-prev]");
          var next = self.querySelector("[data-pairing-next]");
          // children may not be parsed yet on initial load — retry a few frames, and only mark
          // initialised once we've actually found + bound them (so a too-early frame can't disable it)
          if (!track || !prev || !next) {
            if (tries++ < 5) requestAnimationFrame(init);
            return;
          }
          self._init = true;
          var step = function () {
            var c = track.firstElementChild;
            return c ? c.offsetWidth + 12 : track.clientWidth;
          };
          var update = function () {
            var i = Math.round(track.scrollLeft / step());
            prev.disabled = i <= 0;
            next.disabled = i >= track.children.length - 1;
          };
          prev.addEventListener("click", function () {
            track.scrollBy({ left: -step(), behavior: "smooth" });
          });
          next.addEventListener("click", function () {
            track.scrollBy({ left: step(), behavior: "smooth" });
          });
          track.addEventListener("scroll", update, { passive: true });
          update();
        };
        requestAnimationFrame(init);
      }
    },
  );
}
